import {
  CALL_STATUS,
  CALL_STATUS_RESET,
  ACTIVE_CALL_STATUS,
  SET_TOW_DESTINATION_COORDINATES,
} from './call-status.actions'
import { AAACallStatus } from '../calls.types'
import {
  ADD_CALL,
  CALL_CANCEL,
  RESET_ACTIVE_CALLS_CALLED,
} from '../calls.actions'
import { PayloadedAction } from '../../../shared/types'

export interface AAACallsStatusesState {
  activeCall: AAACallStatus | null
  lastCancelledCallKey: string | null
  activeCallCalled: boolean
}

export const initialState: AAACallsStatusesState = {
  activeCall: null,
  lastCancelledCallKey: null,
  activeCallCalled: false,
}

export function reducer(
  state: AAACallsStatusesState | undefined = initialState,
  action: PayloadedAction
): AAACallsStatusesState {
  switch (action.type) {
    case ADD_CALL.SUCCESS:
      return {
        ...state,
        activeCall: {
          ...action.payload.response,
          ...action.payload.data,
          // duplicate some data for temporary call
          towDestination: action.payload.data.towing,
        },
      }
    case ACTIVE_CALL_STATUS.SUCCESS:
      return {
        ...state,
        activeCallCalled: true,
      }
    case RESET_ACTIVE_CALLS_CALLED:
      return {
        ...state,
        activeCallCalled: false,
      }
    case CALL_STATUS.SUCCESS:
      return {
        ...state,
        activeCall: action.payload.data,
      }
    case CALL_CANCEL.SUCCESS:
      return {
        ...state,
        activeCall: null,
        lastCancelledCallKey: action.payload.callKey,
      }
    case SET_TOW_DESTINATION_COORDINATES:
      if (!state.activeCall) {
        return state
      }
      return {
        ...state,
        activeCall: {
          ...state.activeCall,
          towDestination: {
            ...state.activeCall.towDestination,
            latitude: action.payload.lat,
            longitude: action.payload.lng,
          },
        },
      }
    case CALL_STATUS_RESET:
      return {
        ...initialState,
        lastCancelledCallKey: state.lastCancelledCallKey,
      }
    default:
      return state
  }
}
